import 'babel-polyfill';
import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store/store';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import './assets/styles/style.css';
import VueAnalytics from 'vue-analytics';

Vue.config.productionTip = false;

Vue.filter('securityHidden', function (value, code, frontLen, endLen) {
  if (!value) return ''
  if (value.length === 2 && frontLen === 1 && endLen === 1) {
    return value.substring(0,1)+code;
  }
  var len = value.length-frontLen-endLen;
  var xing = '';
  for (var i=0;i<len;i++) {
    xing+=code;
  }
  return value.substring(0,frontLen)+xing+value.substring(value.length-endLen);
})

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');

Vue.use(VueAnalytics, {
  id: 'UA-173442241-1',
  router
})
